import { render, staticRenderFns } from "./CreateLead.vue?vue&type=template&id=112a7034&scoped=true&"
import script from "./CreateLead.vue?vue&type=script&lang=js&"
export * from "./CreateLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112a7034",
  null
  
)

export default component.exports